import { db } from "../helpers/db";
import { DateTime, Interval } from "luxon";
import axios from "../helpers/axios";

const syncFichajesLocal = async (data) => {
  await db.table("fichajes").clear();

  if (data && data.length > 0) {
    for (const element of data) {
      await db.table("fichajes").add(element);
    }
  }
};

export const hasPendingUploads = async () => {
  const fichajes = await db
    .table("fichajes")
    .where("subido")
    .belowOrEqual(1)
    .toArray();

  return fichajes.some(
    (fichaje) => !(fichaje.subido === 1 && fichaje.fecha_sal === null)
  );
};

const getEstadoFichajeLocal = async () => {
  const ultimo = await db
    .table("fichajes")
    .orderBy("id")
    .reverse()
    .limit(1)
    .first();

  const estado = ultimo && ultimo.fecha_sal === null ? "salida" : "entrada";
  localStorage.setItem("entrada", estado);
  return estado;
};

export const getEstadoFichaje = async () => {
  if (window.navigator.onLine) {
    const pending = await hasPendingUploads();

    if (!pending) {
      try {
        const response = await axios.get("fichaje/estado");
        const { estado, data } = response.data;

        await syncFichajesLocal(data);
        localStorage.setItem("entrada", estado);
        return estado;
      } catch (error) {
        console.log(error);
      }
    }
  }

  return await getEstadoFichajeLocal();
};

const getPendingFichajes = async () => {
  const fichajes = await db
    .table("fichajes")
    .where("subido")
    .belowOrEqual(1)
    .toArray()
    .then((array) => array.sort((a, b) => a.id - b.id));

  return fichajes.filter(
    (element) => !(element.subido === 1 && element.fecha_sal === null)
  );
};

export const flushPendingUploads = async () => {
  let ultimo = await db
    .table("fichajes")
    .orderBy("id")
    .reverse()
    .limit(1)
    .first();

  if (ultimo && ultimo.fecha_sal === null) {
    let dt = DateTime.now().toUTC();
    dt = dt.minus({ days: 1 });
    dt = dt.endOf("day");

    let fecha_ultimo = DateTime.fromISO(ultimo.fecha_ing);
    fecha_ultimo = fecha_ultimo.endOf("day");

    let interval = Interval.fromDateTimes(fecha_ultimo, dt);

    if (interval.invalidReason === null && !isNaN(interval.difference())) {
      await db.table("fichajes").update(ultimo.id, {
        fecha_sal: fecha_ultimo.toString(),
        lat_sal: ultimo.lat_ing,
        lng_sal: ultimo.lng_ing,
      });
    }
  }

  const fichajes = await getPendingFichajes();

  if (fichajes.length > 0) {
    return await subir(fichajes);
  }

  return null;
};

export const Cron = async () => {
  try {
    if (window.navigator.onLine && (await hasPendingUploads())) {
      const result = await flushPendingUploads();
      if (result) {
        return result;
      }
    }
  } catch (error) {
    console.log(error);
  }

  return await getEstadoFichaje();
};

export const subir = async (registros) => {
  if (!window.navigator.onLine) {
    return;
  }

  const response = await axios.post("fichaje/marcar/total", {
    data: registros,
  });

  await syncFichajesLocal(response.data.data);

  const messageResult =
    response.data.message ?? "Fichaje registrado correctamente";
  const messageCode = response.data.code ?? "success";
  const data = response.data.data;

  if (data && data.length > 0) {
    const element = data[data.length - 1];
    const textButton = element.fecha_sal === null ? "salida" : "entrada";
    localStorage.setItem("entrada", textButton);
    return [textButton, messageResult, messageCode];
  }

  localStorage.setItem("entrada", "entrada");
  return ["entrada", messageResult, messageCode];
};

/** Punch online: el servidor decide entrada/salida. */
export const marcarOnline = async (lat, lng, fecha) => {
  const response = await axios.post("fichaje/marcar", {
    lat,
    lng,
    fecha,
  });

  await syncFichajesLocal(response.data.data ?? []);

  const messageResult =
    response.data.message ?? "Fichaje registrado correctamente";
  const messageCode = response.data.code ?? "success";
  const estado =
    response.data.estado ??
    (response.data.data?.length > 0 &&
    response.data.data[0].fecha_sal === null
      ? "salida"
      : "entrada");

  localStorage.setItem("entrada", estado);
  return [estado, messageResult, messageCode];
};

/** Fallback offline: el cliente decide según IndexedDB. */
export const guardarFichajeLocal = async (lat, lon, fecha) => {
  const ultim = await db
    .table("fichajes")
    .orderBy("id")
    .reverse()
    .limit(1)
    .first();

  if (ultim && ultim.fecha_sal === null) {
    await db.table("fichajes").update(ultim.id, {
      fecha_sal: fecha,
      lat_sal: lat,
      lng_sal: lon,
    });
  } else {
    await db.table("fichajes").add({
      fecha_ing: fecha,
      lat_ing: lat,
      lng_ing: lon,
      subido: 0,
      fecha_sal: null,
      lat_sal: null,
      lng_sal: null,
    });
  }

  const textButton = await getEstadoFichajeLocal();
  return [
    textButton,
    "Fichaje registrado correctamente",
    "success",
  ];
};
